import { useSelector } from "react-redux";
import _ from "lodash";
import {
  PRODUCT_SKU_COLUMN_MAP,
  transformBillingRows,
  calculateProductTotals,
} from "../billingUtils";

export default function useViewProductSkuTotal(metricKey) {
  const billings = useSelector((state) => state.billing);
  const loading = billings?.loadingBillingsSummary;
  const billingsList = _.get(billings, "billingsSummary.items", []);
  const aggregatedRows = transformBillingRows(billingsList, metricKey);
  const totals = calculateProductTotals(aggregatedRows);

  const rows = [
    {
      teams: totals.teams || "-",
      proactiveSocial: totals.proactiveSocial || "-",
      socialModeration: totals.socialModeration || "-",
      unknown: totals.unknown || "-",
    },
  ];

  const totalCount = rows.length;

  const columns = [
    {
      id: PRODUCT_SKU_COLUMN_MAP.TEAMS,
      label: "Teams",
      width: 120,
      isSortable: false,
      format: (value) => Number(value || 0).toLocaleString("en-US"),
    },
    {
      id: PRODUCT_SKU_COLUMN_MAP.PROACTIVE_SOCIAL,
      label: "Proactive social",
      width: 120,
      align: "right",
      isSortable: false,
      format: (value) => Number(value || 0).toLocaleString("en-US"),
    },
    {
      id: PRODUCT_SKU_COLUMN_MAP.SOCIAL_MODERATION,
      label: "Social Moderation",
      width: 120,
      align: "right",
      isSortable: false,
      format: (value) => Number(value || 0).toLocaleString("en-US"),
    },
    {
      id: PRODUCT_SKU_COLUMN_MAP.UNKNOWN,
      label: "Unknown",
      width: 120,
      align: "right",
      isSortable: false,
      format: (value) => Number(value || 0).toLocaleString("en-US"),
    },
  ];

  return { rows, columns, totalCount, loading };
}
